import * as Scrivito from "scrivito";
import { localizeAttrList } from "^/utils/localizeAttribute";
import imageWidgetIcon from "../../assets/images/image_widget.svg";

Scrivito.provideEditingConfig("ContactWidget", {
  title: "Contact",
  thumbnail: imageWidgetIcon,
  attributes: localizeAttrList(
    [
      "contactPage",
      "contactReason",
      "isAltEmailDisplayed",
      "whichEmailAddress",
      "emailAddressToShow",
      "aspectRatio",
      "showSchema",
      "areaServed",
      "availableLanguage",
      "contactType",
      "hoursAvailable",
    ],
    "ContactWidget"
  ),
  properties: [
    "contactPage",
    "contactReason",
    "isAltEmailDisplayed",
    "whichEmailAddress",
    "emailAddressToShow",
    "aspectRatio",
    "direction",
  ],
  propertiesGroups: [
    {
      title: "Structured Data (Schema.org)",
      properties: [
        "showSchema",
        "areaServed",
        "availableLanguage",
        "contactType",
        "hoursAvailable",
      ],
    },
  ],
  initialContent: {
    isAltEmailDisplayed: "no",
    whichEmailAddress: "primary",
    direction: "row",
    aspectRatio: "1_1",
  },
});
